import { render, staticRenderFns } from "./TrainScreenCheck.vue?vue&type=template&id=71d16686&scoped=true&"
import script from "./TrainScreenCheck.vue?vue&type=script&lang=js&"
export * from "./TrainScreenCheck.vue?vue&type=script&lang=js&"
import style0 from "./TrainScreenCheck.vue?vue&type=style&index=0&id=71d16686&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d16686",
  null
  
)

export default component.exports